import { useCallback } from 'react'
import LookupField from './LookupField'
import UserIdentitySummary from './UserIdentitySummary'

const UserLookupField = ({
  id,
  isRequired = false,
  label,
  onChange,
  searchUsers,
  value = null,
}) => {
  const getInputValue = useCallback(
    (user) => user.email || user.login_id || '',
    [],
  )
  const getOptionKey = useCallback(
    (user) => `${user.login_id}-${user.email}`,
    [],
  )
  const renderUser = useCallback(
    (user) => <UserIdentitySummary user={user} />,
    [],
  )

  return (
    <LookupField
      errorMessage="We could not validate this user. Please try again."
      getInputValue={getInputValue}
      getOptionKey={getOptionKey}
      id={id}
      isRequired={isRequired}
      label={label}
      noResultsMessage="No matching Target users found."
      onSelect={onChange}
      placeholder="Enter email address or ZID"
      renderOption={renderUser}
      renderSelection={renderUser}
      search={searchUsers}
      searchingMessage="Searching users…"
      value={value}
    />
  )
}

export default UserLookupField
